<template>
  <div id="settingIndex" class="aside-menu-to-content">
    <div class="secondary-menu-container">
      <div class="secondary-menu-title">设置</div>
      <second-menu :secondaryMenuMap="secondaryMenuMap"></second-menu>
    </div>
    <div class="content-container">
      <!-- 二级菜单渲染入口 -->
      <router-view></router-view>
    </div>
  </div>
</template>

<script >
// 页面二级菜单
import SecondMenu from 'components/layout/SecondMenu';

export default {
  components: {
    SecondMenu
  },
  data() {
    return {
      secondaryMenuMap: [
        {
          menuName: '账号设置',
          url: 'department',
          childrenMenu: [
            {
              name: '部门管理',
              url: '/admin/setting/department',
              keyword: 'ROLE_DEPARTMENT_show'
            },
            {
              name: '员工账号',
              url: '/admin/setting/employee',
              keyword: 'ROLE_EMPLOYEE_show'
            }
          ]
        },
        {
          menuName: '收款设置',
          url: 'pay-setting',
          keyword: 'ROLE_SETTING_pay_manage',
          childrenMenu: [
            {
              name: '在线支付',
              url: '/admin/setting/online-pay'
            },
            {
              name: '线下支付',
              url: '/admin/setting/offline-pay'
            }
          ]
        },
        {
          menuName: '业务流程设置',
          url: '/admin/setting/business-setting',
          keyword: 'ROLE_SETTING_business',

          childrenMenu: []
        },
        {
          menuName: '系统设置',
          url: '/admin/setting/system-setting',
          keyword: 'ROLE_SETTING_system',
          childrenMenu: []
        }
      ]
    };
  },
  methods: {
    onMenuConfirm(url) {
      // 路由跳转
      console.log('路由--', url);
      this.$router.push({
        path: url
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "common/styles/aside-menu-to-content.scss";
</style>
